<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>Stephen Kolzak</i></span></p>
<p class="ded1"><span><i>my guerrilla, my love</i></span></p>
<p class="ded1"><span><i>1953–1990</i></span></p>
<p class="ded2"><span><i>There are no words anymore</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4fa3191e